import React, { useState, useContext, useMemo, FC } from 'react'
import { MainContainer, HorizontalLine, SelectContainer, DropDownContainer, CustomMenuItems } from './styles'
import { Button, ButtonText } from '../KeywordsComponents/styles'
import CustomDropDown from '../KeywordsComponents/CustomDropDown'
import { AppDataContext } from '../../../providers/AppData'
import { CityWithSpecialties } from '../../../types/homePage'
import { LOCATION_BUTTONS } from 'constants/homePage'
import getDomainName from '../../../utils/getDomainName'
import { MenuItem } from '../KeywordsComponents/CustomDropDown/styles'
import { purifyTenantDomain } from '../../../utils/url'
import useTranslateMessage from '../../../hooks/useTranslateMessage'

type Props = {
  locationsForView: CityWithSpecialties[]
  hospitalsForView: CityWithSpecialties[]
}

const LocationsSection: FC<Props> = ({ locationsForView, hospitalsForView }) => {
  const { language, locale } = useContext(AppDataContext)
  const [selectedType, setSelectedType] = useState(LOCATION_BUTTONS.specialist)
  const [isVisible, setIsVisible] = useState(true)
  const domainName = getDomainName()
  const translate = useTranslateMessage()

  const onSelectType = (e: React.MouseEvent<HTMLButtonElement>) => {
    const newType = e.currentTarget.value
    if (newType === selectedType) {
      return
    }

    setIsVisible(false)
    setTimeout(() => {
      setSelectedType(newType)
      setIsVisible(true)
    }, 300)
  }

  const isSelectedHospitals = useMemo(() => selectedType === LOCATION_BUTTONS.hospital, [selectedType])
  const originWithLang = purifyTenantDomain(domainName, locale)

  const locations = Array.isArray(locationsForView) ? locationsForView : []
  const hospitals = Array.isArray(hospitalsForView) ? hospitalsForView : []

  return (
    <MainContainer>
      <SelectContainer>
        <Button
          active={selectedType === LOCATION_BUTTONS.specialist}
          onClick={onSelectType}
          value={LOCATION_BUTTONS.specialist}
        >
          <ButtonText variant="h3">{translate('homepage.location.specialist')}</ButtonText>
        </Button>
        <Button
          active={selectedType === LOCATION_BUTTONS.clinic}
          onClick={onSelectType}
          value={LOCATION_BUTTONS.clinic}
        >
          <ButtonText variant="h3">{translate('homepage.location.clinic')}</ButtonText>
        </Button>
        <Button
          active={selectedType === LOCATION_BUTTONS.hospital}
          onClick={onSelectType}
          value={LOCATION_BUTTONS.hospital}
        >
          <ButtonText variant="h3">{translate('homepage.location.hospital')}</ButtonText>
        </Button>
      </SelectContainer>

      <HorizontalLine />

      <DropDownContainer isVisible={isVisible} isHospital={isSelectedHospitals}>
        {isSelectedHospitals
          ? hospitals.map((hospital) => (
              <CustomMenuItems key={hospital.id}>
                <MenuItem isHospital href={`${originWithLang}/find/all/${hospital.slug}/hospitals`}>
                  Hospitals in {hospital.name[language]}
                </MenuItem>
              </CustomMenuItems>
            ))
          : locations.map((location) => (
              <CustomDropDown
                key={location.id}
                name={location.name[language]}
                specialties={location.specialties}
                city={location.slug}
                typeOfProfile={selectedType}
              />
            ))}
      </DropDownContainer>
    </MainContainer>
  )
}

export default LocationsSection
